import React, { useEffect, useState } from 'react'
import { Box, Button, Flex, GridItem, Input, FormLabel } from '@chakra-ui/react'

const SlugComponent = ({ onChange, value, showInput, setShowInput }) => {

  const [inputValue, setInputValue] = useState(value)

  useEffect(() => {
    setInputValue(value)
  }, [value])

  const onPressCancel = () => {
    setInputValue(value)
    setShowInput(false)
  }

  return (
    <GridItem gridColumn="1 / -1" className="date-component" gap={4} my={2}>
      {showInput ?
        <Flex gap="2">
          <Button type='submit' colorScheme='teal' size='xs'>Save</Button>
          <Button onClick={onPressCancel} type='button' colorScheme='teal' size='xs'>Cancel</Button>
        </Flex>
        :
        <Button onClick={() => setShowInput(true)} type='button' colorScheme='teal' size='xs'>Edit Slug</Button>}

      <Box display="flex" mt={2} gap={6} border='1px' borderColor='gray.200' borderRadius="md" p={2}>
        <div>
          <FormLabel>Slug</FormLabel>

          {showInput ? <Input
            type='text'
            name='primary_slug'
            onChange={(event) => {
              setInputValue(event.target.value)
              onChange(event.target.value)
            }}
            value={inputValue}
            defaultValue=""
          /> : <span>{inputValue ? inputValue : '-'}</span>}
        </div>
      </Box>
    </GridItem>
  );
};

export default SlugComponent
